import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../store";
import { MdCall } from "react-icons/md";
import { FaVideoSlash, FaVideo } from "react-icons/fa";
import { BiSolidMicrophone, BiSolidMicrophoneOff } from "react-icons/bi";
import { asyncUpdateLocalMedia } from "../redux/members";

interface ActionBarProps {
    setIsEndCall: (value: boolean) => void;
}

const ActionBar: React.FC<ActionBarProps> = ({ setIsEndCall }) => {
    const [isVideoOn, setIsVideoOn] = useState(true);
    const [isAudioOn, setIsAudioOn] = useState(true);
    // const [localStream, setLocalStream] = useState<MediaStream | null>(null);
    // const videoStream = useRef<MediaStream | null>(null);

    // useEffect(() => {
    //     // Khởi tạo luồng phương tiện
    //     navigator.mediaDevices.getUserMedia({ video: true, audio: true })
    //         .then(stream => {
    //             videoStream.current = stream;
    //             // Bạn có thể gán stream này cho một video element nếu muốn
    //         })
    //         .catch(error => {
    //             console.error("Error accessing media devices.", error);
    //         });

    //     return () => {
    //         // Dọn dẹp khi component unmounts
    //         videoStream.current?.getTracks().forEach(track =>{console.log(track); track.stop()});
    //     };
    // }, []);

    const dispatch = useDispatch<AppDispatch>();

    const onToggleCamera = () => {
        // if (videoStream.current) {
        //     videoStream.current.getVideoTracks().forEach(track =>{console.log(track); track.enabled = true});
        // }
        dispatch(asyncUpdateLocalMedia({
            is_video_on: !isVideoOn,
            is_audio_on: isAudioOn,
        }));
        setIsVideoOn(!isVideoOn);
    };

    const onToggleMic = () => {
        // if (videoStream.current) {
        //     videoStream.current.getAudioTracks().forEach(track => track.enabled = !isAudioOn);
        // }
        dispatch(asyncUpdateLocalMedia({
            is_video_on: isVideoOn,
            is_audio_on: !isAudioOn,
        }));
        setIsAudioOn(!isAudioOn);
    };

    const onReleaseCall = () => {
        // window.location.href = "https://app.dem.chat";
        setIsEndCall(true)
    };

    return (
        <div className='flex items-center justify-around lg:justify-center w-full bg-zinc-900'>
            <button 
                className="text-white m-3 mr-10 w-14 h-14 flex justify-center items-center rounded-full bg-zinc-600" 
                onClick={onToggleCamera}
            > 
                {!isVideoOn ? <FaVideoSlash size={30} /> : <FaVideo size={30} />} 
            </button>
            <button 
                className="text-white m-3 mr-10 w-14 h-14 flex justify-center items-center rounded-full bg-zinc-600" 
                onClick={onToggleMic}
            > 
                {!isAudioOn ? <BiSolidMicrophoneOff size={30} /> : <BiSolidMicrophone size={30} />} 
            </button>
            <button 
                className="text-white m-3 mr-10 w-14 h-14 flex justify-center items-center rounded-full bg-red-600" 
                onClick={onReleaseCall}
            > 
                <MdCall size={30} />
            </button>
        </div>
    );
};

export default ActionBar;
